import { FunctionComponent, useState } from "react";

import { Modal } from "@/components";
import {
	useDeleteColumnTemplateMutation,
	useGetCustomColumnTemplatesQuery,
} from "@/pages/Private/redux/column/column.api";

import { classNames } from "@/utils/classNames";
import { TextArea } from "@/components/TextArea/TextArea";

import { ColumnTemplate } from "../../../schema/column-template";

import { replaceWithoutValues } from "../../../utils/column-utils";

interface PromptLibraryModalProps {
	isOpen: boolean;
	onClose: () => void;
	selectPrompt: (prompt: ColumnTemplate) => Promise<void>;
}

export const PromptLibraryModal: FunctionComponent<PromptLibraryModalProps> = ({
	isOpen,
	onClose,
	selectPrompt,
}) => {
	const [selectedColumnTemplate, setSelectedColumnTemplate] = useState<ColumnTemplate | null>(null);

	const [showDeleteModal, setShowDeleteModal] = useState(false);

	const { data: columnTemplates, isLoading: isLoadingColumnTemplates } =
		useGetCustomColumnTemplatesQuery();

	const [deleteColumnTemplate, { isLoading: isDeletingColumnTemplate }] =
		useDeleteColumnTemplateMutation();

	return (
		<Modal
			checkbox={false}
			checkboxLabel=""
			handleClose={onClose}
			handleSave={() => {
				if (selectedColumnTemplate) {
					selectPrompt(selectedColumnTemplate);
				}

				onClose();
			}}
			handleSecondSave={() => {
				if (selectedColumnTemplate && selectedColumnTemplate.id) {
					setShowDeleteModal(true);
				}
			}}
			isLoading={isLoadingColumnTemplates || isDeletingColumnTemplate}
			isOpened={isOpen}
			secondSubmitButtonText="Delete Prompt Template"
			size="lg"
			submitButtonText={"Select Prompt"}
			title="Select Prompt"
		>
			<div className="flex flex-row gap-4">
				<div className="flex flex-col gap-2 w-1/2">
					{columnTemplates?.data.map((columnTemplate) => (
						<div
							key={columnTemplate.id}
							className={classNames(
								"flex flex-row items-center text-sm cursor-pointer p-2 rounded-md",
								selectedColumnTemplate?.id === columnTemplate.id && "bg-action-200 text-action"
							)}
							onClick={() => setSelectedColumnTemplate(columnTemplate)}
						>
							<div>{columnTemplate.name}</div>
						</div>
					))}
				</div>
				<div className="flex flex-col gap-2 w-1/2">
					<TextArea
						className="!mb-0 grow mr-4 max-h-[192px]"
						name={"randomValue"}
						placeholder="Enter value"
						showError={false}
						value={
							(selectedColumnTemplate?.config &&
								replaceWithoutValues(JSON.parse(selectedColumnTemplate?.config.toString()))) ||
							""
						}
					/>
				</div>
			</div>
			{showDeleteModal && (
				<Modal
					handleClose={() => setShowDeleteModal(false)}
					handleSave={() => {
						if (selectedColumnTemplate && selectedColumnTemplate.id) {
							deleteColumnTemplate(selectedColumnTemplate.id);
							setShowDeleteModal(false);
							setSelectedColumnTemplate(null);
						}
					}}
					isOpened={showDeleteModal}
					submitButtonText="Delete"
					title="Delete Prompt Template"
				>
					<div>Are you sure you want to delete this prompt template?</div>
				</Modal>
			)}
		</Modal>
	);
};
